<template>
	<section v-if="isLoading"
           class="loading wh100 fixed top0 left0 z999999 flex-center">
    <div class="lds-dual-ring"></div>
	</section>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    name: 'loading',
    computed: {
      ...mapState({
        isLoading: 'isLoading'
      })
    }
  }
</script>

<style lang="less">
	.loading {
    background-color: rgba(0, 0, 0, 0.7);
    .lds-dual-ring {
      display: inline-block;
      width: 64px;
      height: 64px;
    }
    .lds-dual-ring:after {
      content: " ";
      display: block;
      width: 46px;
      height: 46px;
      margin: 1px;
      border-radius: 50%;
      border: 5px solid #fff;
      border-color: #fff transparent #fff transparent;
      animation: lds-dual-ring 1.2s linear infinite;
    }
    @keyframes lds-dual-ring {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }

  }
</style>